import {
    goalViewState,
} from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
const def = (obj) => obj || {};

export const
    selectedIndex = (state, props) => def(def(goalViewState(state, props).subgoals)[props.subgoalId]).tabIndex || 0,
    tabs = (props) => {
        return props.tabs;
    },
    selectedTabId = (state, props) => {
        const
            index = selectedIndex(state, props),
            tabsArray = tabs(props);
        if (index < 0 || index >= tabsArray.length) {
            // should throw but we don't have an error consumption mechanism so we default to the generic error string
            return ADV.settings.MsgLib.generic_error;
        }
        return tabsArray[index];
    };
